// @flow

import React, { type Node } from 'react';
import { getSafeOxxoUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';
import { Button } from '@tectonics/look-and-feel/shopify/commons/atoms';

export function SaveToPdfButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <SavePdfButton
      type="primary"
      as="a"
      target="blank"
      href={getSafeOxxoUrl(incomingPayment) + '&format=pdf'}
      flat
      outline
      outlineColor="#2397d4"
    >SALVAR BOLETA EN PDF
    </SavePdfButton>
  );
}

const SavePdfButton = styled(Button)`
  font-size: 14px;
  font-weight: 700;
  margin: 5px 0;
  border-radius: 5px;
  width: 100%;
`;
